import { useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

type BudgetDistributorGroupInfo = components['schemas']['GetBudgetDistributorGroupInfoEndpoint_GetDistributorGroupInfoResponse'];

export function useBudgetGetDistributorGroupInfo() {
  const queryClient = useQueryClient();
  const { getAccessToken } = useAuth();

  const getDistributorGroupInfo = (organizationId: number, userId: string): Promise<BudgetDistributorGroupInfo | null> =>
    queryClient.fetchQuery({
      queryKey: ['budget-group-distributor-info', organizationId, userId],
      queryFn: async () => {
        const client = createApiClient(getAccessToken);
        try {
          const { data } = await client.GET('/api/organizations/{organizationId}/users/budget-group/distributor', {
            params: {
              path: { organizationId },
              query: { UserId: userId },
            },
          });
          return data ?? null;
        } catch (err) {
          if (err instanceof Error && err.message.startsWith('HTTP 404:')) {
            return null;
          }
          throw err;
        }
      },
    });

  return { getDistributorGroupInfo };
}
